import { useEffect, useState } from "react";
import { Form, Col, Row, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { getModifiedResponse } from "../../../global/utils/responseModifier";

export const PurchaseItemForm = ({ onCancel, productionRefetch }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [form] = Form.useForm();
  const { id } = useParams();

  const postUrl =
    id && `${process.env.REACT_APP_API_URL}/api/purchases/${id}/items/`;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/licensecodes/getoptions/`;
  const licenseUrl = selectedItem
    ? `${process.env.REACT_APP_API_URL}/api/licensecodes/codes/?limit=10&sort_by=Item&order=asc&page=1&Item=${selectedItem}`
    : null;

  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);

  const {
    data: licenseOptionData,
    loading: licenseOptionDataLoading,
    error: licenseOptionDataError,
    refetch: licenseOptionDataRefetch,
  } = useGet(licenseUrl);
  const licenseOptions = licenseOptionData?.data
    ?.filter((item) => !(selectedItem === 1 && [3, 4].includes(item.Code)))
    .map((item) => ({
      label: item.CodeName,
      value: item.Code,
    }));
  const modifiedItems = getModifiedResponse(optionData, "items");

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const onFinish = async (values) => {
    const modValues = {
      ...values,
    };
    try {
      await postAction(modValues);
    } catch (error) {
      openErrorNotification("Something went wrong.");

      console.log(error);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ItemCount: 10,
    });
  }, []);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
    } else if (!postLoading && !postError && postData) {
      productionRefetch();
      onCancel();
      openConfirmNotification("Success");
    }
  }, [postError, postData, postLoading]);

  return (
    <>
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div className={`px-2 pt-0 pb-3`}>
          <Row gutter={[16, 8]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <CustomSelect
                label="License Item"
                name="Item"
                options={modifiedItems}
                placeholder="Please select"
                required
                loading={optionDataLoading}
                onChange={(value) => {
                  setSelectedItem(value);
                  form.setFieldsValue({
                    Code: undefined,
                  });
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <CustomSelect
                label="License"
                name="Code"
                options={licenseOptions}
                placeholder="Please select"
                required
                loading={licenseOptionDataLoading}
                disabled={!selectedItem}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <CustomInput label="Item Count" name="ItemCount" type="number" />
            </Col>
          </Row>
        </div>
      </Form>

      <div className="flex justify-center space-x-2 mt-2.5">
        <Button
          type="primary"
          className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
          onClick={() => form.submit()}
          loading={postLoading}
          disabled={postLoading}
        >
          <CheckCircleOutlined className="!text-[14px] font-medium" />
          <span className="">Apply</span>
        </Button>
        <Button className="reset-button" onClick={onCancel}>
          <CloseOutlined />
          <span className="">Cancel</span>
        </Button>
      </div>
    </>
  );
};
